import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

export default function BasicCard() {
  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Nova versão
        </Typography>
        <Typography variant="h5" component="div">
          SIG 2
        </Typography>
        <Typography variant="body2">
          Atualização em andamento.
          <br />
          <br />
          Sistema original disponibilizado integralmente.
        </Typography>
      </CardContent>
    </Card>
  );
}
